import { getProjectLookup } from '@/api/project'
import { clearAuthInfo, getAuthInfo } from '@/utils/auth'
import {
  clearProjectContext,
  getProjectContext,
  saveProjectContext,
  type ProjectContext
} from '@/utils/projectContext'

/**
 * 프로젝트 lookup 후 ProjectContext 저장.
 * 로그인 직후 또는 대시보드 진입 시 context가 없을 때 호출.
 */
export async function bootstrapProjectContext(projectCode: string): Promise<ProjectContext> {
  const data = await getProjectLookup(projectCode)
  saveProjectContext(data)
  return data
}

/** 인증·프로젝트 세션 일괄 삭제 */
export const clearSession = (): void => {
  clearAuthInfo()
  clearProjectContext()
}

/**
 * 로그인 상태인데 ProjectContext가 없으면 lookup으로 복구.
 * @returns 복구된 context, 복구 불필요 시 기존 context, projectCode 없으면 null
 */
export async function ensureProjectContext(): Promise<ProjectContext | null> {
  const existing = getProjectContext()
  if (existing != null) return existing

  const projectCode = getAuthInfo()?.projectCode?.trim()
  if (!projectCode) return null

  return bootstrapProjectContext(projectCode)
}
